import React from "react";
import CardContent from "../../../components/comment/carddetailcontent/cardDetailContent";
import CheckBox from "../../../components/comment/checkboxwrap/checkbox";

import {  Button } from "antd";
// const { Option } = Select;

// const handleChange = (value) => {
//   console.log(`selected ${value}`);
// };

const cardDetails = () => {
  return (
    <div className="car-detail-wrap">
      <div className="rightbar-title">Add new card details</div>

      <CardContent/>

        <CheckBox />

      <div className="process-wrap">
        <Button className="process" type="primary">
          Process
        </Button>
      </div>
    </div>
  );
};

export default cardDetails;
